import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app w-full max-w-[768px] mx-auto focus:ring-1 focus:ring-sky-500" }

import { ref } from 'vue';
import BaseHeader from '@/components/global/Header/BaseHeader.vue';
import router from './router';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showHeader = ref<Boolean>(false)
router.beforeEach((to, from) => {
  async function checkHeader() {
    if (to.name !== 'EnterNumberPage') {
      showHeader.value = true
    } else {
      showHeader.value = false
    }
  }
  checkHeader()

});


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showHeader.value)
      ? (_openBlock(), _createBlock(BaseHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_RouterView)
  ]))
}
}

})